import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UploadPhotoComponent } from '../upload-photo/upload-photo.component';
import { MatDialog } from '@angular/material/dialog';
import { ProductCard } from '../../../product/models/product-card';
import { UnitConverter } from '../../utils/unitConverter';
import { DefaultProductParams } from '../../models/defaultProductParams';
import { SHARED_MODULES } from '../../../shared.';
import { SanitizerPipe } from '../../pipes/sanitizer.pipe';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';

@Component({
    selector: 'app-image-select',
    templateUrl: 'image-select.component.html',
    styleUrls: ['image-select.component.scss'],
	imports: [SHARED_MODULES, SanitizerPipe, PhIconComponent, PhIconWrapperComponent],
    standalone: true
})
export class ImageSelectComponent implements OnInit {
	height: number;
	width: number;
	previewWidth: number;
	previewHeight: number;

	@Input() image: string;
	@Input() modalTitle: string;
	@Input() product: ProductCard;
	@Input('height') set setHeight(value: number) {
		this.height = value || UnitConverter.getConvertValue(new DefaultProductParams().height);
		this.setPreviewSizes();
	};
	@Input('width') set setWidth(value: number) {
		this.width = value || UnitConverter.getConvertValue(new DefaultProductParams().width);
		this.setPreviewSizes();
	};
	@Input() canEdit: boolean = true;
	@Input() disabled: boolean = false;
	@Input() label: string = 'PRODUCT_CARD.CHANGE_PHOTO';
	@Input() containerHeight: number = 112;
	@Input() containerWidth: number = 180;
	@Input() opacity: number = 1;

	@Output() edit: EventEmitter<string> = new EventEmitter<string>();

	constructor(private dialog: MatDialog) {}

	ngOnInit(): void {
		if (this.product) {
			if (!this.width) this.width = this.product.params.width;
			if (!this.height) this.height = this.product.params.height;

			this.setPreviewSizes();
		}
	}

	change(): void {
		this.configureProduct();
	}

	delete(): void {
		this.edit.emit(null);
	}

	configureProduct() {
		const dialogRef = this.dialog.open(UploadPhotoComponent, {
			width: '724px',
			autoFocus: false,
			backdropClass: "back-drop",
			data: {
				title: this.modalTitle,
				product: this.product
					?
					{
						id: this.product.id,
						name: this.product.name,
						barcode: this.product.params.barcode,
						width: this.width,
						height: this.height
					}
					: null,
				photo: this.image
			}
		});

		dialogRef.afterClosed().subscribe(async result => {
			if (!result) return;

			this.edit.emit(result);
		});
	}

	setPreviewSizes(): void {
		if (this.width / this.height > this.containerWidth / this.containerHeight) {
			this.previewWidth = this.containerWidth;
			this.previewHeight = Math.round(this.containerWidth * this.height / this.width);
		} else {
			this.previewHeight = this.containerHeight;
			this.previewWidth = Math.round(this.containerHeight * this.width / this.height);
		}
	}
}
